<template>
  <v-expansion-panel v-if="getDisplayType === 'item'">
    <v-expansion-panel-header class="pa-0 pr-5">
      <v-list-item>
        <v-list-item-avatar class="mr-3">
          <v-icon size="20px" class="deep-purple--text">fal fa-envelope-open-dollar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>
            <span class="mr-5">{{ printDate }}</span>
            <span>{{ `小計：${getContent.total}`}}</span>
          </v-list-item-subtitle>
          <v-list-item-title>
            <MarkTag :text="'海外送金'" :match="getQuery" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-slot:actions>
        <v-icon>fal fa-angle-down</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pb-0">
      <Layout ref="layout"
        :status="getStatus"
        :item="getItem"
        :parent="getParent"
        @emit="emitted"
      />
      <v-divider></v-divider>
      <v-list-item class="grow">
        <v-list-item-content>
          <v-list-item-title class="caption" :class="{ 'teal--text': didIPost, 'text--darken-2': didIPost }">
            <v-icon x-small>fa-user-edit</v-icon>&nbsp;{{ `${printAuthor}` }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            v-if="didIPost"
            color="secondary"
            :icon="$vuetify.breakpoint.smAndDown"
            :outlined="$vuetify.breakpoint.mdAndUp"
            :loading="isLoading"
            @click.stop="edit">
            <v-icon small :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }">fal fa-pencil</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">編集する</span>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-expansion-panel-content>
  </v-expansion-panel>
  <v-card v-else color="white" class="mb-3">
    <v-card-title class="title pa-0">
      <v-list-item dense>
        <v-list-item-avatar class="mr-2">
          <v-icon class="deep-purple--text">fal fa-envelope-open-dollar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <MarkTag :text="'海外送金'" :match="getQuery" />
        </v-list-item-content>
        <v-list-item-action>
          <v-menu left>
            <template v-slot:activator="{ on }">
              <v-btn text fab small v-on="on" color="secondary">
                <v-icon small>fas fa-ellipsis-v</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-if="didIPost" @click="remove()">
                <v-list-item-avatar>
                  <v-icon small color="red">fal fa-trash-alt</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>削除する</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="body-1 text-xs-left">
      <Layout ref="layout"
        :status="getStatus"
        :item="getItem"
        :parent="getParent"
        @emit="emitted"
      />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="grey lighten-4">
      <v-list-item class="grow">
        <v-list-item-content>
          <v-list-item-title class="caption" :class="{ 'teal--text': didIPost, 'text--darken-2': didIPost }">
            <v-icon x-small>fa-user-edit</v-icon>&nbsp;{{ `${printAuthor}（${printDate}）` }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            v-if="didIPost"
            color="secondary"
            :icon="$vuetify.breakpoint.smAndDown"
            :outlined="$vuetify.breakpoint.mdAndUp"
            :loading="isLoading"
            @click.stop="edit">
            <v-icon small :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }">fal fa-pencil</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">編集する</span>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card-actions>
    <Confirmer ref="confirmer" />
  </v-card>
</template>

<script>
import MarkTag from '@/components/tags/mark'
import Confirmer from '@/components/modals/confirm'
import Layout from './layout'
export default {
  name: 'posterTransfer',
  components: {
    MarkTag,
    Confirmer,
    Layout
  },
  props: [
    'item',
    'display',
    'authors'
  ],
  data () {
    return {
      config: {
        status: {
          loading: false
        },
        page: 'summary'
      },
      store: {
        parent: {}
      }
    }
  },
  mounted () {
  },
  methods: {
    emitted: function (req) {
      const { action, data } = req || {}
      if (action && typeof this[action] === 'function') {
        this[action](data)
      }
    },
    edit: function () {
      const { gid } = this.$props.item || { content: '' }
      if (this.store.parent && this.store.parent.id) {
        this.$emit('emit', {
          action: 'edit',
          data: this.store.parent
        })
      } else if (gid) {
        this.submit({ type: 'edit' })
      }
    },
    remove: function () {
      this.$refs.confirmer.open({
        message: 'この投稿を削除してもよろしいですか？',
        callback: () => {
          this.submit({ type: 'remove' })
        }
      })
    },
    updated: function () {
      this.$set(this.store, 'parent', {})
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { gid } = this.$props.item
      const aid = this.$store.getters['author/get']('userid')
      const cid = this.$route.params.id
      const urls = {
        edit: `${this.$url.api}posts/get/transfers/${gid}`,
        detail: `${this.$url.api}posts/get/transfers/${gid}`,
        remove: `${this.$url.api}posts/remove/item/${gid}`
      }
      const fds = {
        edit: {},
        detail: {},
        remove: { cid, aid, type: 'transfer' }
      }
      if (type && urls[type] && fds[type]) {
        if ([ 'edit', 'detail', 'remove' ].includes(type)) {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'loading', true)
          return { url, fd, type }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, postType) {
      const socket = this.$store.getters['config/get']('socket')
      const type = postType || ''
      if (postType === 'edit') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.store, 'parent', req)
        this.$nextTick(() => {
          this.$emit('emit', {
            action: 'edit',
            data: this.store.parent
          })
        })
      } else if (postType === 'detail') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.store, 'parent', req)
        this.$nextTick(() => {
          this.$refs.layout.mvDetails()
        })
      } else if (postType === 'remove') {
        socket.emit('POST_POST_TRANSFER', req, (res) => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    getQuery () {
      return this.$route.query && this.$route.query.query || ''
    },
    getStatus () {
      return this.config.status
    },
    getItem () {
      return this.$props.item || {}
    },
    getParent () {
      return this.store.parent
    },
    getDisplayType () {
      return this.$props.display || 'card'
    },
    printTitle () {
      return this.$props.item ? this.$props.item.title : ''
    },
    printAuthor () {
      return (
        this.$props.item &&
        this.$props.item.aid &&
        this.$props.authors &&
        this.$props.authors[this.$props.item.aid]
      ) ? this.$props.authors[this.$props.item.aid].name[0] : ((this.$props.item && this.$props.item.aid) ? this.$props.item.aid : '')
    },
    printDate () {
      return (
        this.$props.item &&
        this.$props.item.date
      ) ? this.$moment(this.$props.item.date).format('YYYY年MM月DD日') : ''
    },
    didIPost () {
      return (
        this.$props.item &&
        this.$props.item.aid &&
        (this.$props.item.aid === 'guest' || this.$props.item.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer'))
      )
    }
  }
}
</script>
